export default {"src":"/_next/static/image/public/images/ic_watch_hc.bfe2575f07de69a5cc7232ab1c63fc35.svg","height":12,"width":13};